module.exports = __webpack_public_path__ + "static/media/Body Diagram.4ce05532.png";